export default __webpack_public_path__ + "static/media/arrowConversion.5c8a9d16.svg";